// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ef33667d","453":"f6148f60","667":"b408da78"}[chunkId] + ".chunk.js";
};